/**
 * Shopify Storefront Client Configuration
 * Adapted for TanStack Start with Vite environment variables
 */
import { createStorefrontClient } from "@shopify/hydrogen-react";
import { ApiVersion } from "@shopify/shopify-api";

const isServer = typeof globalThis.window === "undefined";

export const storeFrontApiVersion = ApiVersion.April26; // Update as needed

const client = createStorefrontClient({
  privateStorefrontToken: isServer
    ? process.env.STOREFRONT_API_PRIVATE_ACCESS_TOKEN
    : undefined,
  publicStorefrontToken: isServer
    ? undefined
    : import.meta.env.VITE_STOREFRONT_API_PUBLIC_ACCESS_TOKEN,
  storeDomain: import.meta.env.VITE_SHOPIFY_STORE_URL,
  storefrontApiVersion: storeFrontApiVersion,
});

export const getStorefrontApiUrl = client.getStorefrontApiUrl;
export const getPrivateTokenHeaders = client.getPrivateTokenHeaders;
export const getPublicTokenHeaders = client.getPublicTokenHeaders;
